/**
 * Builds a /depart/ search URL matching ui-react's expected format.
 * Centralizes URL construction to avoid inconsistencies across components.
 *
 * Shape: `/[locale/]depart/origin/destination/date/[returnDate/][?query]`
 *
 * The return value feeds a **click handler**, never an `href`
 * (→ `invariants.md#no-transient-search-links`) — so pass `locale` wherever the
 * consumer needs a locale-prefixed path, since no i18n `Link` will add it.
 */
export function buildDepartUrl(params: {
    origin: string
    destination: string
    date: string
    returnDate?: string
    locale?: string
    query?: Record<string, string>
}): string {
    const { origin, destination, date, returnDate, locale, query } = params
    const prefix = locale ? `/${locale}` : ''
    let path = `${prefix}/depart/${encodeURIComponent(origin)}/${encodeURIComponent(destination)}/${date}/`
    if (returnDate) {
        path += `${returnDate}/`
    }

    if (!query || Object.keys(query).length === 0) {
        return path
    }

    const qs = new URLSearchParams(query)
    return `${path}?${qs}`
}
